"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _list_component = _interopRequireDefault(require("../component/list_component"));

var _data = require("../config/data");

var _index = require("../utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var MonthPanel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(MonthPanel, _PureComponent);

  function MonthPanel() {
    _classCallCheck(this, MonthPanel);

    return _possibleConstructorReturn(this, _getPrototypeOf(MonthPanel).apply(this, arguments));
  }

  _createClass(MonthPanel, [{
    key: "canUse",
    value: function canUse(theYear) {
      var monthData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props = this.props,
          _this$props$optionalS = _this$props.optionalStartDateData,
          optionalStartDateData = _this$props$optionalS === void 0 ? {} : _this$props$optionalS,
          _this$props$optionalE = _this$props.optionalEndDateData,
          optionalEndDateData = _this$props$optionalE === void 0 ? {} : _this$props$optionalE,
          startYear = _this$props.startYear,
          startMonth = _this$props.startMonth,
          endYear = _this$props.endYear,
          endMonth = _this$props.endMonth,
          type = _this$props.type,
          _this$props$hideEndDa = _this$props.hideEndDatePanel,
          hideEndDatePanel = _this$props$hideEndDa === void 0 ? false : _this$props$hideEndDa;
      var optionalStartYear = optionalStartDateData.year,
          optionalStartMonth = optionalStartDateData.month;
      var optionalEndYear = optionalEndDateData.year,
          optionalEndMonth = optionalEndDateData.month;
      var result = false;

      if ((theYear > optionalStartYear || theYear === optionalStartYear && monthData.value >= optionalStartMonth) && (theYear < optionalEndYear || theYear === optionalEndYear && monthData.value <= optionalEndMonth)) {
        result = true;

        if (type === 'start') {
          // 隐藏面板就不需要跟跟结束日期做对比了
          if ((0, _index.compareDate)({
            year: theYear,
            month: monthData.value
          }, {
            year: startYear,
            month: startMonth
          }) > 0 && (0, _index.compareDate)({
            year: theYear,
            month: monthData.value
          }, {
            year: endYear,
            month: endMonth
          }) >= 0 && !hideEndDatePanel) {
            result = false;
          }
        } else if (type === 'end') {
          if ((0, _index.compareDate)({
            year: theYear,
            month: monthData.value
          }, {
            year: endYear,
            month: endMonth
          }) < 0 && (0, _index.compareDate)({
            year: theYear,
            month: monthData.value
          }, {
            year: startYear,
            month: startMonth
          }) <= 0) {
            result = false;
          }
        }
      }

      return result;
    }
  }, {
    key: "getData",
    value: function getData() {
      var _this = this;

      var _this$props2 = this.props,
          year = _this$props2.year,
          _this$props2$optional = _this$props2.optionalStartDateData,
          optionalStartDateData = _this$props2$optional === void 0 ? {} : _this$props2$optional,
          _this$props2$optional2 = _this$props2.optionalEndDateData,
          optionalEndDateData = _this$props2$optional2 === void 0 ? {} : _this$props2$optional2;
      var optionalStartYear = optionalStartDateData.year;
      var optionalEndYear = optionalEndDateData.year;
      var result = []; // 进行月份筛选

      if (year < optionalStartYear || year > optionalEndYear) {
        result = [];
      } else {
        _data.MONTH_LIST.map(function (item) {
          var data = {};

          if (item) {
            data = _objectSpread({}, item);
            data.disabled = !_this.canUse(year, item);
            result.push(data);
          }

          return item;
        });
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          onChange = _this$props3.onChange,
          month = _this$props3.month,
          _this$props3$classNam = _this$props3.classNameMap,
          classNameMap = _this$props3$classNam === void 0 ? {} : _this$props3$classNam;
      return _react["default"].createElement(_list_component["default"], {
        classNameMap: classNameMap,
        value: month,
        data: this.getData(),
        onChange: onChange
      });
    }
  }]);

  return MonthPanel;
}(_react.PureComponent);

_defineProperty(MonthPanel, "propTypes", {
  data: _spauiUtils.PropTypes.array,
  year: _spauiUtils.PropTypes.number,
  month: _spauiUtils.PropTypes.number,
  onChange: _spauiUtils.PropTypes.func
});

_defineProperty(MonthPanel, "defaultProps", {
  data: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
});

var _default = MonthPanel;
exports["default"] = _default;